(function () {
    'use strict';

    angular.module('swif.framework')

    .factory('swifResourcesService', swifResourcesService);

    /**
    * @ngdoc service
    * @name swif.framework.swifResourcesService
    * @description provide a way to add resources to the current page like fullcalendar, d3
    * @requires swif.framework.swifFrameworkService
    **/
    function swifResourcesService ($q, settings) {
        'ngInject';
        var service = {};
        service.scripts = [];
        service.styles = [];
        service.resources = [];
        service.add = function (resources) {
            var promises = [];
            _.forEach(resources, function (resource) {
                if (!_.contains(service.resources, resource)) {
                    service.resources.push(resource);
                    promises.push(service._add(resource));
                }
            });
            return $q.all(promises);
        };
        service._add = function (resource, deferred) {
            if (!service._scripts) {
                service._scripts = settings.app.resources.scripts;
            }
            if (!_.isEmpty(service._scripts[resource])) {
                //include next only as browser behavior
                if (!deferred) {
                    deferred = $q.defer();
                }
                var script = document.createElement('script');
                var src = service._scripts[resource].shift();
                src += '?' + SWIF_RESOURCES_VERSION;
                script.onload = function() {
                    if (!_.isEmpty(service._scripts[resource])) {
                        service._add(resource, deferred);
                    } else {
                        deferred.resolve(true);
                    }
                };
                script.src = src;
                document.getElementById('resources').appendChild(script);
                return deferred.promise;
            }
            return $q.when(true);
        };
        return service;
    }

})();
